import React from 'react'
import { SVGIcon } from '~/utils/types'


export const LaboFlame = (props: SVGIcon) => (
  <svg
    {...props}
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="none"
      d="M12.9317847,26.7495286 C8.51470316,24.5416971 6.56449419,21.50236 7.08115781,17.6315171 C7.85615323,11.8252529 13.799196,6.58556194 14.4563348,1 C14.4400071,0.998436961 21.6050126,5.27943984 25.5187205,15.1232807 C26.6673541,18.442073 25.8289465,21.7534494 24.6672128,23.3478639 C23.9851807,24.6527621 22.2403334,25.8701408 19.4326712,27 C21.7567714,24.5308823 22.9188216,22.2650834 22.9188216,20.2026032 C22.9188216,17.1088829 21.5750152,13.1513979 17.664345,9.9616419 C17.6400433,14.0212189 16.9368138,16.9066147 15.5546563,18.6178294 C15.5599963,18.6279841 15.4367911,17.6360127 14.6303343,16.354794 C14.4416046,16.054959 14.016042,15.6444546 13.3536465,15.1232807 C13.1847364,15.7563685 12.544476,17.1910944 11.4328653,19.4274582 C10.3504285,22.0070725 10.8500683,24.4477626 12.9317847,26.7495286 Z"
      id="Path-13"
      stroke="#FFF"
      stroke-linejoin="round"
    ></path>
    <path
      fill="#FFF"
      d="M16.4924242,20 C16.7343192,20 16.9352546,20.1740582 16.9769206,20.4038647 L16.9848485,20.4924242 L16.9848485,30.9418788 C16.9848485,31.2140106 16.764556,31.434303 16.4924242,31.434303 C16.2507047,31.434303 16.0496328,31.2602092 16.0079344,31.0304265 L16,30.9418788 L16,20.4924242 L16.0079344,20.4038766 C16.0496328,20.1740938 16.2507047,20 16.4924242,20 Z"
      id="Fill-7"
      fillRule="nonzero"
    ></path>
  </svg>
)
